"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight } from "lucide-react";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
const wp_query_params = {
  per_page: 3,
  order: "desc",
  orderby: "date"
};
const wp_query = new WP_Query(wp_query_params);
function FeaturedPropertiesConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="146952" className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-primary-foreground/10">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="p-8 h-[400px] animate-pulse bg-primary-foreground/5" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="p-8 text-center text-primary-foreground/60 text-sm border-t border-primary-foreground/10">
        Nessun approfondimento legale disponibile al momento.
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-primary-foreground/10">
      {products.slice(0, 3).map((product, i) => <article key={product.id} data-index={i} className="group flex flex-col bg-primary hover:bg-primary-foreground/5 transition-colors duration-500">
          <Link to={product.link} className="block relative aspect-[4/3] overflow-hidden bg-primary/80 border-b border-primary-foreground/10">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center text-primary-foreground/40">
                Immagine non disponibile
              </div>}
            <div className="absolute top-4 left-4">
              <Badge className="bg-accent text-accent-foreground rounded-none uppercase tracking-widest text-[10px] border-none px-3 py-1">
                Focus Legale
              </Badge>
            </div>
          </Link>
          <div className="p-6 lg:p-8 flex flex-col flex-grow">
            <h4 className="text-lg font-semibold tracking-tight mb-3 text-primary-foreground font-sans">
              {product.title}
            </h4>
            {product.short_description && <div className="text-sm text-primary-foreground/70 line-clamp-2 mb-8 font-serif italic" dangerouslySetInnerHTML={{
          __html: product.short_description
        }} />}
            <div className="mt-auto pt-6 border-t border-primary-foreground/10">
              <AddToCartButton productId={product.id} variant="outline" className="w-full" buttonClassName="bg-accent text-accent-foreground rounded-none w-full uppercase tracking-widest text-xs h-12 hover:bg-accent/90 border-none" text="Leggi l'Analisi" showQuantity={false} />
            </div>
          </div>
        </article>)}
    </div>;
}
export default function FirmOverview() {
  const expertiseAreas = ["Diritto Societario e Commerciale"];
  return <section id="testimonial" className="bg-primary text-primary-foreground flex flex-col border-y border-primary-foreground/10">
      <div className="grid grid-cols-1 lg:grid-cols-12 border-b border-primary-foreground/10">
        <div className="lg:col-span-5 p-8 md:p-12 lg:p-16 xl:p-24 border-b lg:border-b-0 lg:border-r border-primary-foreground/10 flex flex-col justify-center">
          
          <h2 className="text-4xl tracking-tighter mb-8 leading-[1.1] font-sans !font-normal lg:text-5xl xl:text-6xl">Lavora con noi</h2>
<p className="text-primary-foreground/80 text-lg leading-relaxed mb-10 !font-sans !text-justify !not-italic">
  <em>"We must believe that we are gifted for something, and that this thing must be attained"</em>&nbsp; 
  <br />M. Curie – premio nobel per la fisica e la chimica 
  <br /><br />
  Nel nostro studio, la curiosità professionale, <strong>l’empatia con il cliente</strong> e <strong>la disponibilità a lavorare in team</strong> sono le fondamenta di ogni nostra azione. Siamo alla ricerca di professionisti che condividano la nostra dedizione a tali principi. 
  <br />Offriamo un ambiente di lavoro che valorizza il talento individuale all'interno di una visione collettiva, dove la crescita professionale è sostenuta da una cultura di apprendimento continuo e rispetto reciproco. 
  <br />Desideri unirti al nostro team?
</p>


          <div className="space-y-4 mb-12">
            {expertiseAreas.map((item, i) => <div key={i} data-index={i} className="flex items-center gap-4 text-sm tracking-wide font-sans">
                
                
              </div>)}
          </div>

          <Button asChild variant="outline" size="lg" className="self-start rounded-none border-primary-foreground/20 hover:bg-accent hover:text-accent-foreground transition-colors uppercase tracking-widest text-xs h-12 px-8">
            
          </Button>
        </div>

        <div className="lg:col-span-7 relative min-h-[500px] lg:min-h-full bg-primary/90">
          <img src="https://studiodclegal.it/wp-content/uploads/2026/03/tavolo3.png" alt="Studio Legale Architectural Detail" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 opacity-80" />
          <div className="absolute inset-0 pointer-events-none border-[20px] border-primary/20 mix-blend-overlay" />
        </div>
      </div>

      <div className="flex flex-col">
        

        <EcommerceProductsProvider className="products-grid-wrapper" wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <FeaturedPropertiesConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}